//
//
//
//

export default {
  name: 'Turnstile',
  props: {
    theme: {
      type: String,
      default: 'auto',
    },
    appearance: {
      type: String,
      default: 'always',
    },
  },
  data() {
    return {
      widgetId: null,
    };
  },
  async mounted() {
    if (this.$turnstile) {
      this.widgetId = await this.$turnstile.render(this.$refs.turnstileContainer, {
        theme: this.theme,
        appearance: this.appearance,
        callback: (token) => {
          this.$emit('input', token);
        },
        'expired-callback': () => {
          this.$emit('input', null);
        },
        'error-callback': () => {
          this.$emit('input', null);
        },
      });
    }
  },
  beforeDestroy() {
    if (this.$turnstile && this.widgetId) {
      this.$turnstile.remove(this.widgetId);
    }
  },
  methods: {
    reset() {
      if (this.$turnstile && this.widgetId) {
        this.$turnstile.reset(this.widgetId);
        this.$emit('input', null);
      }
    },
  },
};
